import { EditFilled, EyeFilled } from "@ant-design/icons";
import { message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useContext, useEffect, useState } from "react";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";
import CustomPagination from "../../commons/components/CustomPagination";
import CustomTable from "../../commons/components/CustomTable";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import { DELETE_MENU, LIST_GROUP_MENU, PREVIEW_GROUP_MENU } from "../../commons/constants/api-urls";
import { routerNavigation } from "../../commons/constants/routers";
import useFetchList from "../../commons/hooks/useFetchList";
import useTable from "../../commons/hooks/useTable";
import { TrashIcon } from "../../commons/resources";
import defaultAxios from "../../commons/utils/axios";
import { AppContext } from "../../contexts/AppContext";
import ModalPreviewGroupMenu from "./ModalPreviewGroupMenu";
import styles from "./styles.module.scss";
import CustomModal from "../../commons/components/CustomModal/CustomModal";
import GradientText from "../../commons/components/GradientText/GradientText";
const GroupMenu = () => {
  const navigate = useNavigate();
  const { storeId } = useParams<{ storeId: string }>();
  const { store, findAndSetStore, setCurrentStore } = useContext(AppContext);
  const { page, setPage, onShowSizeChange, perPage } = useTable();
  const { data, total, refresh, loading, setLoading } = useFetchList<GroupMenuList>(
    LIST_GROUP_MENU(storeId ? storeId : ""),
    {
      page,
      perPage,
      paginationMetadataStyle: "body",
    }
  );

  const [selectedGroup, setSelectedGroup] = useState<GroupMenuList | null>(null);
  const [selectedGroupDelete, setSelectedGroupDelete] = useState<GroupMenuList | null>(null);
  const columns: ColumnsType<GroupMenuList> = [
    {
      title: "No",
      width: 70,
      render: (text, record, index) => {
        return page === 1 ? index + 1 : (page - 1) * perPage + (index + 1);
      },
    },
    {
      title: "Group Name",
      dataIndex: "name",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Product In Group ",
      dataIndex: "productQuantity",
      render: (text, record, index) => {
        return text;
      },
    },
    {
      title: "Preview",
      dataIndex: "isPreviewing",
      render: (text, record, index) => {
        return (
          <div className={styles.edit}>
            <div
              className={`${styles.preview} ${record.isPreviewing && styles.true}`}
              onClick={() => handleMarkMenuReview(record.id, record.isPreviewing)}
            >
              Preview
            </div>
          </div>
        );
      },
    },
    {
      title: "Action ",
      render: (text, record, index) => {
        return (
          <div className={styles.actions}>
            <div className={styles.edit}>
              <EditFilled onClick={() => handleNavigateEdit(record.id, record.name)} />
            </div>
            <div className={styles.delete}>
              <EyeFilled onClick={() => handleOpenModalPreview(record)} />
            </div>
            <div className={styles.delete}>
              <TrashIcon onClick={() => handleOpenModalDelete(record)} />
            </div>
          </div>
        );
      },
    },
  ];

  const handleMarkMenuReview = async (groupId: string, isPrviewing: boolean) => {
    try {
      setLoading(true);
      await defaultAxios.put(PREVIEW_GROUP_MENU(storeId!, groupId, !isPrviewing));
      message.success("Preview menu successfully");
      refresh();
    } catch (error) {
      message.error("Preview menu Failed");
    } finally {
      setLoading(false);
    }
  };

  const handleNavigate = () => {
    navigate(routerNavigation.STORES.CREATE_GROUP_MENU(storeId || ""));
  };

  const handleNavigateEdit = (groupId: string, groupName: string) => {
    navigate({
      pathname: routerNavigation.STORES.EDIT_GROUP_MENU(storeId || "", groupId),
      search: createSearchParams({ groupName }).toString(),
    });
  };

  const handleOpenModalPreview = (groupId: GroupMenuList) => {
    setSelectedGroup(groupId);
  };

  const handleOpenModalDelete = (groupId: GroupMenuList) => {
    setSelectedGroupDelete(groupId);
  };

  const handleDeleteGroupMenu = async (groupId: string) => {
    try {
      setLoading(true);
      await defaultAxios.delete(DELETE_MENU(storeId!, groupId), {});
      message.success("Delete Menu Successfully");
      setSelectedGroupDelete(null);
      setPage(1);
      refresh();
    } catch (error) {
      console.log(error);
      message.error("Delete failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!storeId || store.data.length === 0) return;
    findAndSetStore(storeId);
  }, [storeId, setCurrentStore, store]);

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Group Management</div>
          <div>
            <PrimaryButton className={styles.cloneProductBtn} onClick={handleNavigate}>
              Create New Group
            </PrimaryButton>
          </div>
        </div>
      </div>

      <div className={styles.menuPanel}>
        <div className={styles.paginationWrapper}>
          <p>Group Quantity : {total} </p>
          <CustomPagination
            defaultCurrent={1}
            showSizeChanger
            current={page}
            onChange={page => setPage(page)}
            total={total}
            onShowSizeChange={onShowSizeChange}
            pageSize={perPage}
          />
        </div>
        <CustomTable loading={loading} pagination={false} columns={columns} dataSource={data} scroll={{ x: 400 }} />
      </div>

      {selectedGroup && (
        <ModalPreviewGroupMenu
          group={selectedGroup}
          storeId={storeId!}
          title="Preview Group"
          menuName={selectedGroup.name}
          open={selectedGroup ? true : false}
          onClose={() => {
            setSelectedGroup(null);
          }}
          navigate={handleNavigateEdit}
        />
      )}

      <CustomModal open={selectedGroupDelete ? true : false} className={styles.modalConfirm}>
        <h3>Do you want to delete {selectedGroupDelete?.name} menu ? </h3>
        <div className={styles.btnBox}>
          <div className={styles.btnCancel} onClick={() => setSelectedGroupDelete(null)}>
            <GradientText text={"Cancel"}></GradientText>
          </div>
          <PrimaryButton onClick={() => handleDeleteGroupMenu(selectedGroupDelete?.id!)}>Yes</PrimaryButton>
        </div>
      </CustomModal>
    </div>
  );
};

export default GroupMenu;
